import { postSamlResponse as _postSamlResponse } from "../../../app/core/integrated/IntegratedEligibilityService";

const LOGIN_URL = "#/login";
const DASHBOARD_URL = "/dashboard/#/home";
const ACCOUNTS_URL = "/participant/accounts/#/";

const DynamicArticleRoutingController = function ($scope, $rootScope) {
    $scope.holi = "Hello World";
    $scope.isAuthenticated = false;
    $scope.isFreemium = false;
    $scope.url = LOGIN_URL;

    const previousUrl = document.referrer;

    if (previousUrl.includes("dashboard/")) {
        $scope.isFreemium = true;
    }

    $scope.$watchGroup(["isFreemium", "isAuthenticated"], function (newValues) {
        const [isFreemium, isAuthenticated] = newValues;

        if (isFreemium) {
            $scope.url = DASHBOARD_URL;
        } else if (isAuthenticated) {
            $scope.url = ACCOUNTS_URL;
        } else {
            $scope.url = LOGIN_URL;
        }
    });

    if (Object.prototype.hasOwnProperty.call($rootScope, "css")) {
        if ($rootScope.css.accu !== "not-initialized") {
            $scope.isAuthenticated = true;
        }
    }

    $rootScope.$watch("css.accu", function (newValue, oldValue) {
        if (newValue != oldValue) {
            if (newValue !== "not-initialized") {
                $scope.isAuthenticated = true;
            }
        }
    });
};

DynamicArticleRoutingController.$inject = ["$scope", "$rootScope"];
export default DynamicArticleRoutingController;
